import axios from "../config/axios"

const API_BASE = "/shipments"

export const shipmentService = {
  // Get all shipments with filters - UPDATED
  getAllShipments: (page = null, perPage = null, filters = {}) => {
    const params = {
      ...(page && { page }),
      ...(perPage && { per_page: perPage }),
      ...filters,
    }
    return axios.get(API_BASE, { params })
  },

  // Get shipments with filters (alias) - NEW METHOD
  getShipments: (filters = {}) => {
    const params = { ...filters }
    return axios.get(API_BASE, { params })
  },

  // Get today's shipments
  getTodaysShipments: (page = 1, perPage = 20) => {
    return axios.get(`${API_BASE}/today`, {
      params: { page, per_page: perPage },
    })
  },

  // Get single shipment
  getShipment: (shipmentId) => {
    return axios.get(`${API_BASE}/${shipmentId}`)
  },

  // Create shipment
  createShipment: (data) => {
    const formData = new FormData()

    Object.keys(data).forEach((key) => {
      if (key === "parcel_image_1" || key === "parcel_image_2") {
        if (data[key]) {
          formData.append(key, data[key])
        }
      } else if (key === "eway_bill_numbers") {
        // Handle E-way bills array
        if (data[key] && Array.isArray(data[key]) && data[key].length > 0) {
          formData.append(key, JSON.stringify(data[key]))
        }
      } else if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
        formData.append(key, data[key])
      }
    })

    return axios.post(API_BASE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  // Update shipment
  updateShipment: (shipmentId, data) => {
    let formData = data

    if (!(data instanceof FormData)) {
      formData = new FormData()
      Object.keys(data).forEach((key) => {
        if (key === "parcel_image_1" || key === "parcel_image_2") {
          if (data[key]) {
            formData.append(key, data[key])
          }
        } else if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
          formData.append(key, data[key])
        }
      })
    }

    return axios.put(`${API_BASE}/${shipmentId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  },

  // Soft-delete shipment (requires reason)
  deleteShipment: (shipmentId, reason) => {
    return axios.delete(`${API_BASE}/${shipmentId}`, { data: { reason } })
  },

  // Download invoice
  downloadInvoice: (shipmentId, includeLabour = true) => {
    return axios.get(`${API_BASE}/${shipmentId}/invoice/download`, {
      params: { include_labour: includeLabour ? "yes" : "no" },
      responseType: "blob",
    })
  },

  // Send invoice via email
  sendInvoiceEmail: (shipmentId, includeLabour = true) => {
    return axios.post(`${API_BASE}/${shipmentId}/invoice/send`, {
      include_labour: includeLabour,
    })
  },

  updateStatus: (shipmentId, status, remarks = "", deliveryReceiver = "", deliveryReceiverImage = null) => {
    // If status is Delivered and delivery info is provided, use FormData
    if (status === "Delivered" && (deliveryReceiver || deliveryReceiverImage)) {
      const formData = new FormData()
      formData.append("status", status)
      formData.append("remarks", remarks)
      
      if (deliveryReceiver) {
        formData.append("delivery_receiver", deliveryReceiver)
      }
      
      if (deliveryReceiverImage) {
        formData.append("delivery_receiver_image", deliveryReceiverImage)
      }
      
      return axios.post(`${API_BASE}/${shipmentId}/status`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
    }
    
    // For other statuses, use regular JSON
    return axios.post(`${API_BASE}/${shipmentId}/status`, { status, remarks })
  },

  // Bulk update status with delivery receiver info
  bulkUpdateStatus: (shipmentIds, status, remarks = "", deliveryReceiver = "", deliveryReceiverImage = null) => {
    // If status is Delivered and delivery info is provided, use FormData
    if (status === "Delivered" && (deliveryReceiver || deliveryReceiverImage)) {
      const formData = new FormData()
      formData.append("shipment_ids", JSON.stringify(shipmentIds))
      formData.append("status", status)
      formData.append("remarks", remarks)
      
      if (deliveryReceiver) {
        formData.append("delivery_receiver", deliveryReceiver)
      }
      
      if (deliveryReceiverImage) {
        formData.append("delivery_receiver_image", deliveryReceiverImage)
      }
      
      return axios.post(`${API_BASE}/bulk_status_update`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
    }
    
    // For other statuses, use regular JSON
    return axios.post(`${API_BASE}/bulk_status_update`, {
      shipment_ids: shipmentIds,
      status: status,
      remarks: remarks
    })
  },

  // Get tracking information
  getTrackingInfo: (shipmentId) => {
    return axios.get(`/tracking/${shipmentId}`)
  },

  // Get distinct users
  getDistinctUsers: () => {
    return axios.get(`${API_BASE}/get_distinct_users`)
  },

  // Get statistics
  getStatistics: () => {
    return axios.get(`${API_BASE}/statistics`)
  },

  // Export shipments PDF with filters
  exportPDF: (filters = {}) => {
    return axios.get(`${API_BASE}/export/pdf`, {
      params: filters,
      responseType: "blob",
    })
  },

  // Get location hubs by state
  getLocationHubsByState: (state) => {
    return axios.get("/location-hubs", {
      params: { state },
    })
  },

  // Get all location hubs
  getAllLocationHubs: () => {
    return axios.get("/location-hubs")
  },

  addLabourCharge: (shipmentId, amount, paymentMode) => {
    return axios.post(`${API_BASE}/${shipmentId}/labour-charge`, {
      labour_charge: amount,
      payment_mode: paymentMode,
    })
  },

  addDeliveryCharge: (shipmentId, amount, paymentMode) => {
    return axios.post(`${API_BASE}/${shipmentId}/delivery-charge`, {
      delivery_charge: amount,
      payment_mode: paymentMode,
    })
  },

  addLateCharge: (shipmentId, amount, paymentMode, remarks = "") => {
    return axios.post(`${API_BASE}/${shipmentId}/late-charge`, {
      late_charge: amount,
      payment_mode: paymentMode,
      remarks: remarks,
    })
  },
  
  // Print receipt
  printReceipt: (shipmentId) => {
    return axios.get(`${API_BASE}/${shipmentId}/print-receipt?format=html`)
  },

  // Get E-way bills for a shipment
  getEwayBills: (shipmentId) => {
    return axios.get(`/shipments/eway-bills/${shipmentId}`)
  },

  // Add E-way bills to a shipment
  addEwayBills: (shipmentId, ewayBillNumbers) => {
    return axios.post(`/shipments/eway-bills/${shipmentId}`, {
      eway_bill_numbers: ewayBillNumbers
    })
  },

    // Get customer suggestions (sender + receiver) by name or contact
  getCustomerSuggestions: (name, contact = '') => {
    const params = {}
    if (name) params.name = name
    if (contact) params.contact = contact
    return axios.get(`${API_BASE}/customer-suggestions`, { params })
  },

  // Export Pre-Loading Sheet PDF
  exportPreLoadingSheet: (filters = {}) => {
    return axios.get(`${API_BASE}/export/pre-loading-sheet`, {
      params: filters,
      responseType: "blob",
    })
  },

  // Get booked shipments grouped by sender location
  getBookedShipmentsBySenderLocation: (filters = {}) => {
    return axios.get(`${API_BASE}/booked-by-sender-location`, { params: filters })
  },

  // Delete E-way bill
  deleteEwayBill: (ewayBillId) => {
    return axios.delete(`/shipments/eway-bills/delete/${ewayBillId}`)
  },

}